<div class="bg-white rounded-lg border max-w-xl">

    <div class="px-5 py-2 flex items-center">
        <span class="cursor-grab w-full flex items-center" cdkDragHandle><i class="ri-draggable"></i> <span
                class="text-xs font-semibold">Certificate Form</span></span>
        <span class="divider divider-horizontal"></span>
        <span class="flex gap-3">

            @if (flag == 1) {
            @if (!isPreview) {
            <button class="btn btn-sm btn-circle bg-white text-green-600" [disabled]="coursePublished && flag !== 1 || isSubmitting"
                (click)="!(coursePublished && flag !== 1) && !isSubmitting && addCertificateStructure()">
                @if (isSubmitting) {<i class="ri-loader-4-line animate-spin"></i>}@else{<i class="ri-check-line"></i>}
              </button>
            <button class="btn btn-sm btn-circle bg-white text-red-600" [disabled]="coursePublished && flag !== 1 || isSubmitting"
                (click)="!(coursePublished && flag !== 1) && !isSubmitting && deleteCertificateStructureNew()"><i class="ri-delete-bin-7-line"></i></button>
            }
            }@else{

            @if (isPreview) {
            <button *ngIf="isPreview" class="btn btn-sm btn-circle bg-white text-zinc-600"
[disabled]="coursePublished && flag !== 1"
                (click)="!(coursePublished && flag !== 1) && (isPreview = false)"><i class="ri-pencil-fill"></i></button>
            <button class="btn btn-sm btn-circle bg-white text-red-600" [disabled]="coursePublished && flag !== 1 || isSubmitting"
                (click)="!(coursePublished && flag !== 1) && !isSubmitting && deleteCertificateStructure(certificateData?.id)"><i class="ri-delete-bin-7-line"></i></button>
            }@else{
            <button class="btn btn-sm btn-circle bg-white text-zinc-600" [disabled]="coursePublished && flag !== 1"
                (click)="!(coursePublished && flag !== 1) && closePreview()"><i class="ri-close-line"></i></button>
            <button class="btn btn-sm btn-circle bg-white text-green-600" [disabled]="coursePublished && flag !== 1 || isSubmitting"
                (click)="!(coursePublished && flag !== 1) && !isSubmitting && UpdateCertificateStructure()">
                @if (isSubmitting) {<i class="ri-loader-4-line animate-spin"></i>}@else{<i class="ri-check-line"></i>}
              </button>
            }
            }

        </span>
    </div>
    <hr>
    @if (isPreview) {
    <!-- preview -->
    <div class="p-5">
        <div class="w-full bg-white flex items-center gap-5 h-[7rem]">

            <!-- Image -->
            <div class="w-[8rem] h-full shrink-0">
                <img
                    class="h-full w-full object-cover rounded-md"
                    src="assets/certificate_icon.png"
                    alt="Certificate">
            </div>

            <!-- Details -->
            <ul class="w-full capitalize space-y-2 overflow-hidden">

                <li class="flex items-center gap-2">
                    <span class="uppercase text-xs text-zinc-500 shrink-0">
                        Certificate ID :
                    </span>

                    <span
                        class="font-medium text-sm truncate max-w-[200px]"
                        [title]="certificateData?.certificate_id">

                        {{ certificateData?.certificate_id || 'N/A' }}

                    </span>
                </li>

                <li class="flex items-center gap-2">
                    <span class="uppercase text-xs text-zinc-500 shrink-0">
                        Activities :
                    </span>

                    <span class="font-medium text-sm">
                        {{ certificateData?.activities_to_be_considered || 'N/A' }}
                    </span>
                </li>

            </ul>
        </div>
    </div>
    <!-- preview -->
    }@else {
    <!-- form -->
    <div class="p-5">
        <form [formGroup]="certificateForm">
            <div class="grid grid-cols-2 gap-5">

                <div class="col-span-2">
                    <label class="form-control w-full">
                        <div class="label">
                            <span class="label-text text-sm font-semibold req">Select Certificate</span>
                        </div>
                        <select formControlName="certificate_id" class="select select-sm select-bordered w-full"
                            [ngClass]="{ 'error': certificateForm.get('certificate_id')?.touched && certificateForm.get('certificate_id')?.hasError('required') }">
                            <option value="" disabled selected>Select Certificate</option>
                            <option value="1">Certificate 1</option>
                            <option value="2">Certificate 2</option>
                            <option value="3">Certificate 3</option>
                        </select>
                        @if (certificateForm.get('certificate_id')?.touched &&
                        certificateForm.get('certificate_id')?.hasError('required')){
                        <span class="text-xs text-red-500">Please select a certificate</span>
                        }
                    </label>
                </div>

                <!-- <div class="col-span-2">
                    <label class="form-control w-full">
                        <div class="label">
                            <span class="label-text text-sm font-semibold req">Activities to be Considered</span>
                        </div>
                        <textarea formControlName="activities_to_be_considered" placeholder="Enter activities to be considered for this certificate"
                            class="textarea textarea-bordered w-full"
                            [ngClass]="{ 'error': certificateForm.get('activities_to_be_considered')?.touched && certificateForm.get('activities_to_be_considered')?.hasError('required') }"></textarea>
                        @if (certificateForm.get('activities_to_be_considered')?.touched &&
                        certificateForm.get('activities_to_be_considered')?.hasError('required')){
                        <span class="text-xs text-red-500">Activities are required</span>
                        }
                    </label>
                </div> -->

            </div>
        </form>
    </div>
    <!-- form -->
    }

</div>